<template>
  <div>
    <div class="container">
      <ul class="nav nav-tabs nav-justified">
        <li v-for="(tab, index) in tabs" :key="index" class="nav-item" :class="{'active': tab.isActive}">
            <a :href="tab.href" @click="selectTab(tab)" style="font-size: 25px;">{{$t(translateName(tab.name))}}</a>
        </li>
        <br/>
      </ul>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>  
</template>

<script>
export default {
  data() {
    return {tabs: []};
  },

  created() {
    this.tabs = this.$children;
  },

  methods: {
    translateName(name) {
        switch (name) {
            case 'processing':
                return 'flow.processing'

            case 'finished':
                return 'flow.finished'
        }
    },
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
          tab.isActive = (tab.name == selectedTab.name);
      });
    }
  }  
}
</script>


// WEBPACK FOOTER //
// src/pages/comp/tabs.vue